import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "AddNew"
});
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "currentColor"
};
const _hoisted_2 = /* @__PURE__ */ _createStaticVNode('<path fill-rule="evenodd" clip-rule="evenodd" d="M2.25 4C2.25 3.0335 3.0335 2.25 4 2.25H8.75V3.75H4C3.86193 3.75 3.75 3.86193 3.75 4V8.75H2.25V4Z"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M3.75 15.25V20C3.75 20.1381 3.86192 20.25 4 20.25H8.75V21.75H4C3.03351 21.75 2.25 20.9665 2.25 20V15.25H3.75Z"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M21.75 15.25V20C21.75 20.9665 20.9665 21.75 20 21.75H15.25V20.25H20C20.1381 20.25 20.25 20.1381 20.25 20V15.25H21.75Z"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M15.25 2.25H20C20.9665 2.25 21.75 3.03351 21.75 4V8.75H20.25V4C20.25 3.86192 20.1381 3.75 20 3.75H15.25V2.25Z"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M7.25 11.25H16.75V12.75H7.25V11.25Z"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M12.75 7.25V16.75H11.25V7.25H12.75Z"></path>', 6);
const _hoisted_8 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_8);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/AddNew.vue"]]);
